<template>
  <v-app class="bg-color">
    <v-main>
      <v-container fluid grid-list-xs pt-5>
        <v-layout row wrap justify-center align-center>
          <v-flex xs11 lg11>
            <h2>
              <v-icon color="#077893" @click="Fn_BackIndex" size="38"
                >mdi-chevron-left</v-icon
              >{{ $t("Cookies.detail") }}
            </h2>
          </v-flex>
        </v-layout>

        <v-layout row wrap justify-center align-center pt-5>
          <v-flex xs11 lg11>
            <v-card class="rounded-lg">
              <v-card-title primary-title class="pa-2 pl-4 black--text">
                <!-- {{ $t("Cookies.detail") }}<v-spacer></v-spacer> -->
                {{ ServiceName }}<v-spacer></v-spacer>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout row wrap justify-center pt-8 pa-3 class="black--text">
                  <v-flex xs11 sm11 lg8 md8>
                    <v-layout row wrap>
                      <v-flex xs11 sm11 lg6 md6>
                        <b> ชื่อ QR Code : </b> {{ ServiceName }}
                        <div class="mt-5">
                          <div v-if="$t('default') === 'th'">
                            <b> วันที่ดำเนินการ : </b> {{ UpdatdeAt }}
                          </div>
                          <div v-else>
                            <b> Update date : </b> {{ UpdatdeAtEng }}
                          </div>
                        </div>
                      </v-flex>
                      <v-flex xs11 sm11 lg6 md6>
                        <b> CMP Service secret :</b>
                        <span class="blurry-text">{{ SecretId }}</span>
                        <v-icon
                          color="#077893"
                          style="cursor: pointer"
                          small
                          @click="Fn_CopyDetail(SecretId)"
                          >mdi-file-multiple-outline</v-icon
                        >
                        <div class="mt-5">
                          <div v-if="$t('default') === 'th'">
                            <b> วันที่หมดอายุ : </b> {{ CreatedAt }}
                          </div>
                          <div v-else>
                            <b> Expire date : </b> {{ CreatedAtEng }}
                          </div>
                        </div>
                      </v-flex>
                      <v-flex xs11 sm11 lg12 md12>
                        <h2 class="pt-10 black--text">
                          {{ $t("Cookies.consent") }}
                        </h2>
                        <div v-if="GroupId == ''">
                          {{ $t("Cookies.type") }}:
                          <b>
                            <v-chip
                              class="ma-2"
                              color="#ddf7ff"
                              text-color="#077893"
                            >
                              {{ $t("Cookies.general") }}
                            </v-chip>
                          </b>
                        </div>
                        <div v-else>
                          {{ $t("Cookies.type") }}:
                          <b>
                            <v-chip
                              class="ma-2"
                              color="#ddf7ff"
                              text-color="#077893"
                            >
                              {{ $t("Cookies.group") }}
                            </v-chip>
                          </b>
                        </div>
                        <div v-if="GroupId == ''" class="black--text">
                          <v-flex xs12 lg12 md12>
                            {{ $t("Cookies.Consentnumber") }} :
                            <b> {{ ConsentId }}</b>
                            &nbsp;
                            <v-icon
                              color="#077893"
                              style="cursor: pointer"
                              small
                              @click="Fn_CopyDetail(ConsentId)"
                              >mdi-file-multiple-outline</v-icon
                            >
                          </v-flex>
                          <v-flex xs12 lg12 md12>
                            {{ $t("Cookies.Policynumber") }} :
                            <b> {{ PolicyId }}</b>
                            &nbsp;
                            <v-icon
                              color="#077893"
                              style="cursor: pointer"
                              small
                              @click="Fn_CopyDetail(PolicyId)"
                              >mdi-file-multiple-outline</v-icon
                            >
                          </v-flex>
                        </div>
                        <div v-else>
                          <v-flex xs12 lg12 md12>
                            {{ $t("Cookies.groupnumber") }} :
                            <b> {{ GroupId }}</b>
                            &nbsp;
                            <v-icon
                              color="#077893"
                              style="cursor: pointer"
                              small
                              @click="Fn_CopyDetail(GroupId)"
                              >mdi-file-multiple-outline</v-icon
                            >
                          </v-flex>
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs11 sm11 lg4 md4>
                    <center>
                      <v-btn
                        v-if="QrcodeExpire === true"
                        @click="Fn_Refresh"
                        small
                        outlined
                        color="success"
                      >
                        <v-icon left>mdi-refresh</v-icon> รีเฟรช QR Code
                      </v-btn>
                      <v-card outlined width="198" class="mt-3">
                        <img
                          width="190"
                          :src="'data:image/jpeg;base64,' + Qrcode"
                        />
                      </v-card>
                      <h2 class="black--text mt-3">Scan QR code</h2>
                    </center>
                  </v-flex>
                  <v-flex xs12 lg12>
                    <b v-if="$t('default') === 'th'">นโยบาย: </b>
                    <b v-else>Policy: </b
                    ><a
                      @click="Fn_DetailPolicy"
                      class="text-decoration-underline"
                      >{{ Policy.PolicyHeader }}</a
                    >
                  </v-flex>
                  <v-flex xs12 lg12>
                    <b v-if="$t('default') === 'th'">ความยินยอม: </b>
                    <b v-else>Consent: </b>
                    <div v-for="(item, i) in Consent" :key="i">
                      <a
                        @click="fn_DetailConsent(item)"
                        class="text-decoration-underline"
                        >{{ i + 1 }}. {{ item.ConsentHeader }}
                      </a>
                      <br />
                    </div>
                  </v-flex>
                </v-layout>
                <v-layout row wrap justify-center ma-0 pa-2>
                  <v-flex xs9 lg3 pa-4>
                    <v-card outlined class="cyan lighten-5 rounded-lg">
                      <v-card-text class="pa-2 text-center black--text">
                        <div v-if="$t('default') === 'th'">
                          <p style="font-size: 18px; color: #00695c">ทั้งหมด</p>
                        </div>
                        <div v-else>
                          <p style="font-size: 18px; color: #00695c">All</p>
                        </div>
                        <v-chip color="#00695C" dark
                          >{{ all }} {{ $t("consentlist.list") }}</v-chip
                        >
                      </v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex xs9 lg3 pa-4>
                    <v-card outlined class="teal lighten-5 rounded-lg">
                      <v-card-text class="pa-2 text-center black--text">
                        <p style="font-size: 18px; color: #077893">
                          {{ $t("dashboard.statusapp") }}
                        </p>
                        <v-chip color="#077893" dark
                          >{{ approve }} {{ $t("consentlist.list") }}</v-chip
                        >
                      </v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex xs9 lg3 pa-4>
                    <v-card outlined class="red lighten-5 rounded-lg">
                      <v-card-text class="pa-2 text-center black--text">
                        <p style="font-size: 18px; color: #803636">
                          {{ $t("dashboard.reject") }}
                        </p>
                        <v-chip color="#803636" dark
                          >{{ unapprove }} {{ $t("consentlist.list") }}</v-chip
                        >
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
                <v-divider></v-divider>
                <v-data-table
                  no-data-text="ไม่พบข้อมูล"
                  :loading-text="$t('overlay.load')"
                  :headers="headers"
                  :items="DataConsent"
                  :page.sync="page"
                  :items-per-page="itemsPerPage"
                  hide-default-footer
                  @page-count="pageCount = $event"
                  scrollable
                >
                  <template v-slot:[`item.SendId`]="{ item }">
                    <div class="text-left">
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            color="#077893"
                            style="cursor: pointer"
                            small
                            @click="Fn_CopyDetail(item.SendId)"
                            v-on="on"
                            >mdi-file-multiple-outline</v-icon
                          >
                        </template>
                        <span>{{ $t("consentlist.copy") }}</span>
                      </v-tooltip>
                      {{ item.SendId }}
                    </div>
                  </template>
                  <template v-slot:[`item.CreatedAt`]="{ item }">
                    <div v-if="$t('default') === 'th'">
                      {{ item.CreatedAt }}
                    </div>
                    <div v-else>
                      {{ item.CreatedAtEng }}
                    </div>
                  </template>
                  <template v-slot:[`item.Status`]="{ item }">
                    <v-chip
                      color="green"
                      dark
                      v-if="item.Status === 'Active'"
                      >{{ $t("petition.text22v2") }}</v-chip
                    >
                    <v-chip
                      color="error"
                      dark
                      v-else-if="item.Status === 'Unactive'"
                      >{{ $t("petition.text23") }}</v-chip
                    >
                    <v-chip
                      color="warning"
                      dark
                      v-else-if="item.Status === 'Pending'"
                      >{{ $t("petition.text24") }}</v-chip
                    >
                    <v-chip
                      color="black"
                      dark
                      v-else-if="item.Status === 'expire'"
                      >{{ $t("dashboard.expire") }}</v-chip
                    >
                  </template>
                </v-data-table>
                <div class="text-center pt-2">
                  <v-pagination
                    :total-visible="7"
                    class="pt-2 pb-2"
                    circle
                    color="#077893"
                    v-model="page"
                    :length="pageCount"
                    prev-icon="mdi-menu-left"
                    next-icon="mdi-menu-right"
                  ></v-pagination>
                </div>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
      <div v-if="loadingDownloadData">
        <OverlaySearch />
      </div>
      <DialogPolicy
        :show="DialogPolicy"
        :_detail="Policy"
        @closeDialogDelete="DialogPolicy = false"
      />
      <DialogConsent
        :show="DialogConsent"
        :_detail="DetailsConsent"
        @closeDialogDelete="DialogConsent = false"
      />
    </v-main>
  </v-app>
</template>

<script>
import DialogConsent from "@/components/dialog/DialogQrcodeConsentDetail.vue";
import DialogPolicy from "@/components/dialog/DialogQrcodePolicyDetail.vue";
import OverlaySearch from "@/components/layouts/LoadingPage.vue";
import Swal2 from "sweetalert2/dist/sweetalert2.js";
import { mapGetters } from "vuex";
// import authorization from "@/functions/authorization.js";
// import 'sweetalert2/src/sweetalert2.scss'
const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default {
  components: { DialogPolicy, DialogConsent, OverlaySearch },
  data: function () {
    return {
      loadingDownloadData: false,
      Qrcode: "",
      QrcodeExpire: false,
      DialogPolicy: false,
      DialogConsent: false,
      SecretId: "",
      CreatedAt: "",
      CreatedAtEng: "",
      ServiceName: "",
      UpdatdeAt: "",
      UpdatdeAtEng: "",
      GroupId: "",
      ConsentId: "",
      PolicyId: "",
      SecretIdCopy: "",
      all: "",
      approve: "",
      unapprove: "",
      Policy: [],
      Consent: [],
      DetailsConsent: [],
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      DataConsent: [],
      NoData: "No data available",
    };
  },
  computed: {
    ...mapGetters(["Business"]),
    ...mapGetters(["RoleAccount"]),
    ...mapGetters(["Profile"]),

    _RoleAccount: {
      get() {
        return this.RoleAccount || "-";
      },
    },
    _SelectTaxId: {
      get() {
        return this.Business.TaxId || "-";
      },
    },
    headers() {
      return [
        {
          text: "Send ID",
          value: "SendId",
          align: "center",
          sortable: false,
        },
        {
          text: "Name",
          align: "center",
          value: "Name",
          sortable: false,
        },
        {
          text: this.$i18n.t("consentlist.date"),
          value: "CreatedAt",
          sortable: false,
          align: "center",
        },
        {
          text: this.$i18n.t("dashboard.status"),
          value: "Status",
          sortable: false,
          align: "center",
        },
      ];
    },
  },
  companyth: {
    get() {
      if (this.$i18n.locale === "th") {
        return this.profile.name_on_document_th;
      } else {
        return this.profile.name_on_document_eng;
      }
    },
  },
  mounted() {
    this.Fn_GetService();
  },
  methods: {
    async Fn_CopyDetail(val) {
      this.disabledFirst = false;
      if (val === this.SecretId) {
        val = this.SecretIdCopy;
        await navigator.clipboard.writeText(val);
      } else {
        await navigator.clipboard.writeText(val);
      }
    },
    Fn_BackIndex() {
      this.$router.push("/qrcode-index");
    },
    async Fn_GetService() {
      this.loadingDownloadData = true;
      var payload = {
        AccountId: this.$cookies.get("OneAccountId"),
        BusinessId: this.$cookies.get("BusinessId"),
        QrcodeId: this.$cookies.get("QrcodeId"),
      };
      // var Headers = {
      //   AccountId: this.$cookies.get("OneAccountId"),
      // };
      // var dataEncode = await authorization.encodeDataNew(payload);
      // var auth = await authorization.encodeDataNew(Headers);
      // var headers = { Authorization: "Bearer " + auth };

      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "qrcode/GetQrcodeDetails",
          payload
          // { Data: dataEncode },
          // { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;
          if (response.data.Status === "OK") {
            this.Service = response.data.Message;
            this.Name = response.data.Message.Qrcode.NameTh;
            this.NameEng = response.data.Message.Qrcode.NameEng;
            this.Qrcode = response.data.Message.Qrcode.Qrcode;
            this.QrcodeExpire = response.data.Message.Qrcode.QrcodeExpire;
            this.CreatedAt = response.data.Message.Qrcode.QrcodeExpireAtTh;
            this.CreatedAtEng = response.data.Message.Qrcode.QrcodeExpireAtEng;
            this.SecretId = response.data.Message.Qrcode.Id.slice(0, 10);
            this.SecretIdCopy = response.data.Message.Qrcode.Id;
            this.ServiceName = response.data.Message.Qrcode.QrcodeName;
            this.UpdatdeAt = response.data.Message.Qrcode.UpdatdeAt;
            this.UpdatdeAtEng = response.data.Message.Qrcode.UpdatdeAtEng;
            this.GroupId = response.data.Message.Detail.GroupId;
            this.ConsentId = response.data.Message.Detail.Consent[0].ConsentId;
            this.PolicyId = response.data.Message.Detail.Policy.PolicyId;
            this.Policy = response.data.Message.Detail.Policy;
            this.Consent = response.data.Message.Detail.Consent;
            this.DataConsent = response.data.Message.Consent;
            this.all = response.data.Message.Count.All;
            this.approve = response.data.Message.Count.Approve;
            this.unapprove = response.data.Message.Count.UnApprove;

            if (this.QrcodeExpire === true) {
              Toast.fire({
                icon: "warning",
                title: "QR Code หมดอายุ",
                text: "กรุณารีเฟรช QR Code ใหม่อีกครั้ง",
              });
            }
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.Message.Status,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    Fn_Refresh() {
      var payload = {
        QrcodeId: this.$cookies.get("QrcodeId"),
        AccountId: this.$cookies.get("OneAccountId"),
        BusinessId: this.$cookies.get("BusinessId"),
      };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "qrcode/RefreshQrcode",
          payload
        )
        .then((response) => {
          if (response.data.Status === "OK") {
            this.QrcodeExpire = false;
            Toast.fire({
              icon: "success",
              title: "รีเฟรช QR Code สำเร็จ",
            });
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.Message.Status,
            });
          }
        })
        .catch((error) => {
          this.tableload = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    Fn_DetailPolicy() {
      this.DialogPolicy = true;
    },
    async fn_DetailConsent(item) {
      this.DetailsConsent = item;
      this.DialogConsent = true;
    },
  },
};
</script>
<style scoped>
.bg-color {
  background-color: #ddf7ff;
}

.blurry-text {
  font-size: 14px;
  color: transparent;
  text-shadow: 0 0 8px #000;
}

.textcolor {
  color: #077893;
}
</style>
